import { GridColumnType } from "../../../../data/gridColumnType";


// gmapApplicationTasklistTableConfig 
export const gmapApplicationTasklistTableConfig = {
  columns: [
    {
      name: "Submission Date",
      fieldName: "submissionDate",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD MMM YYYY',
      }
    },
    {
      name: "Applicant Name",
      fieldName: "name",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Email Address",
      fieldName: "email",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "GMP Tier",
      fieldName: "applicationName",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "statusName",
      colType: GridColumnType.Text,
    },
    {
      name: "Source",
      fieldName: "source",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false
      },
      customAction: [
        {

          name: "UPDATE",
          // iconName: AppIcons.copyIcon,
          onViewAction: (data) => {
            alert("called permissions");
          },
        },
      ],
    },
  ],
};
